
import type { HttpError } from '../domain/error';


// RequestType : vehicles, vehicle, fleet, fleets, user....

// Take api response error as param and check status, if ok return else throw error (dont set the data here)
export const handleAxiosError = (error : HttpError, requestType : string) => {
    if (error.response?.status === 200) return;
    else throw new Error(`Error on ${requestType} request: ${error.response?.data?.description ?? error.response?.data?.error?.message}`);
};